import React, { useEffect } from "react";
import { Card, Divider, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FaStar } from "react-icons/fa";
import { formatDateTimeOrNull } from "utils/index";
import { DATE_FORMAT } from "variables/constants";
import { FileText } from "lucide-react";
import { 
  getMonthlyPerfReviewItems 
} from "../../redux/performancereviewitem/performanceReviewItemState";
import { useNavigate } from "react-router-dom";

const ReviewHistoryCard = (props) => {
  const { recordData } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reviewItems = useSelector(
    (state) => state.performanceReviewItem.monthlyPerfReviewItems.items
  );

  useEffect(() => {
    dispatch(getMonthlyPerfReviewItems({ for_5th_month: 1 }));
  }, [dispatch]);

  const ratingClassMap = {
    "Exceeds": "exceeds",
    "Meets": "meets",
    "Needs Improvement": "developing",
    "Does not meet expectations": "needs-focus",
  };

  const ratings = recordData.pfr_result?.sections?.flatMap(section =>
    section.categories.map(category => {
      const criterion = reviewItems.find(
        item => item.pri_id === category.pri_id
      );

      const ratingItem = reviewItems.find(
        item =>
          item.pri_parent_id === category.pri_id &&
          item.stars === category.rating
      );

      const evaluation = ratingItem?.pri_title?.replace(/^\d+\s*/, "") || "";

      return {
        criteria: criterion?.pri_title || `Criterion ${category.pri_id}`,
        evaluation,
        className: ratingClassMap[evaluation] || "",
      };
    })
  ) || [];

  return (

    <Card className="flex flex-col rounded-2xl border border-green-200 shadow-sm dark-mode-card">
      <div>
        <div className="flex items-start justify-between gap-4 text-lg">
          <div>
            <h4 className="font-semibold text-gray-800 dark:text-white">{recordData.employee_name}
              <span className="text-xs mx-2 border status-indicator completed">Completed</span>
            </h4>
            
            <div className="flex items-center text-gray-600 text-sm dark:text-gray-100">
              Review Period: {recordData.review_month}
            </div>
          </div>
          <div>
            {recordData.type_name === "Monthly" ? (
              <div className="flex items-center space-x-2 text-gray-900">
                <FaStar className="text-yellow-500 w-5 h-5" />
                <span className="font-semibold dark:text-white">
                  {recordData.pfr_result?.rating}
                </span>
              </div>
            ) : (
              <span
                className={`text-base status-indicator ${
                  {
                    "Exceeds": "exceeds",
                    "Meets": "meets",
                    "Needs improvement": "developing",
                    "Does not meet expectations": "needs-focus",
                  }[recordData.pfr_result?.overall_result] || ""
                }`}
              >
                {recordData.pfr_result?.overall_result}
              </span>
            )}
            <span className="flex text-gray-500 text-sm items-end justify-end">Overall Rating</span>
          </div>
        </div>

      </div>
      <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />
      {recordData.type_name == "Monthly" && 
        <div className="mb-4 text-lg">
          <div className="flex items-center text-gray-600 dark:text-gray-200">
            Reason
          </div>
          <p className="text-gray-800 dark:text-gray-200">{recordData.pfr_result?.reason}</p>
        </div>
      }
      <div className="grid grid-cols-2 gap-4 text-lg">
          <div>
            <div className="flex items-center text-gray-600 dark:text-gray-200">
              Review Date
            </div>
            <h4 className="font-semibold text-gray-800 dark:text-gray-200">{formatDateTimeOrNull(recordData.updated_at, DATE_FORMAT)}</h4>
          </div>
          <div>
            <div className="flex items-center text-gray-600 dark:text-gray-200">
              Reviewed By
            </div>
            <h4 className="font-semibold text-gray-800 dark:text-gray-200">{recordData.rated_by}</h4>
          </div>
      </div>

      {recordData.type_name != "Monthly" && 
        <>
          <div className="flex gap-2 my-4 grid grid-cols-4 ">
            {ratings.map(({ criteria, evaluation, className }) => (
              <div key={criteria} className="flex-1 gap-1 text-10px">
                <div className="title-text">{criteria}</div>
                <span className={`text-10px status-indicator ${className}`}>
                  {evaluation}
                </span>
              </div>
            ))}
          </div>        
          <Button
            block
            type="default"
            className="btn-base title-text flex items-center mt-4" 
            onClick={() => navigate(`/console/performance-reviews/${recordData.pfr_id}/view`)}
          >
            <FileText className="w-4 h-4"/> View Full Review
          </Button>
        </>
      }
    </Card>
  );
};

export default ReviewHistoryCard;
